import React, { useState, useEffect, Fragment } from "react";
import { TabPane, Button } from "reactstrap";
import SiteComment from "../SiteComment";
import SiteCommentBox from "../SiteCommentBox";
import ApiCaller from "../../../../api/apiCaller";
import "./index.css";
import { Select } from "shared";
import { SelectItem } from "shared/components/Input/type";
import api from "api";
import t from "utils/Lang";

interface SiteCommentTabInputProps {
  isView?: boolean;
  site?: any;
  siteId?: any;
  isCanEdit?: boolean;
  userBrandId?: number;
}

const SiteCommentTab = ({
  isView,
  site,
  siteId,
  isCanEdit,
  userBrandId,
}: SiteCommentTabInputProps) => {
  const optionDefault = { label: t().site_listing__all, value: "all" };
  const [statusOptions, setStatusOptions] = useState<Array<SelectItem>>([]);
  const [selectedStatus, setSelectedStatus] = useState<Array<SelectItem>>([
    optionDefault,
  ]);
  const [siteComments, setSiteComments] = useState<Array<any>>([]);
  const [isLoadComment, setIsLoadComment] = useState<boolean>(false);
  const [commentPage, setCommentPage] = useState<number>(0);
  const [totalComments, setTotalComments] = useState<number>(0);
  const [sitePerformanceEstimationFields, setSitePerformanceEstimationFields] =
    useState<Array<any>>([]);
  const commentLimit = 10;

  const getSitePerformanceEstimationFields = async () => {
    const uri = `site_comment/fields_info`;
    const res = await ApiCaller.get(uri);
    if (res.status === "ok") {
      setSitePerformanceEstimationFields(res.result);
    } else {
      alert(res.msg);
    }
  };

  const getSiteComments = async () => {
    setIsLoadComment(true);
    let uri = `site_comment/list?site_id=${siteId}&page=${commentPage}&limit=${commentLimit}`;
    if (selectedStatus?.length > 0 && selectedStatus?.[0]?.value != "all") {
      uri += `&status_id=${selectedStatus?.[0]?.value}`;
    }
    const res = await ApiCaller.get(uri);
    if (res?.result) {
      if (commentPage == 0) {
        setSiteComments(res.result);
      } else {
        setSiteComments([...siteComments, ...res.result]);
      }
      setIsLoadComment(false);
      setTotalComments(res?.total);
    }
  };

  const loadMoreComment = () => {
    setCommentPage(commentPage + 1);
  };

  const onCommentSavedHandler = (newCommentData: any) => {
    console.log(newCommentData);
    setSiteComments([newCommentData, ...siteComments]);
  };

  useEffect(() => {
    if (siteId) {
      getSiteComments();
    }
  }, [commentPage, selectedStatus]);

  useEffect(() => {
    getSitePerformanceEstimationFields();
    if (userBrandId) getStatus();
  }, [userBrandId]);

  const getStatus = async () => {
    const optionStatus = [optionDefault];
    const resStatus = await api.getStatusListing(userBrandId);
    if (resStatus?.result) {
      resStatus?.result?.forEach((item: any) => {
        if (item?.code !== "rejected" && item?.code !== "completed") {
          optionStatus.push({
            value: item?.id,
            label: item?.name,
          });
        }
      });
      setStatusOptions(optionStatus);
    }
  };

  const onFilterStatus = (data: Array<SelectItem>) => {
    setCommentPage(0);
    setSelectedStatus(data);
  };

  return (
    <TabPane tabId="site_comment_tab">
      <br />
      <div className="site-comment-tab__outter-container">
        <div className="site-comment-tab__container">
          <div style={styles.commentBoxContainer}>
            <SiteCommentBox
              siteId={siteId}
              onCommentSaved={onCommentSavedHandler}
              sitePerformanceEstimationFields={sitePerformanceEstimationFields}
            />
          </div>
          <span className="site-comment__filter-title">
            {t().site_comment__filter_comment_by_status}
          </span>
          <Select
            style={{ marginTop: 10, width: 300 }}
            label={t().site_listing__status}
            data={statusOptions}
            onChanged={onFilterStatus}
            editable
            values={selectedStatus}
          />
          {isLoadComment && (
            <p style={{ marginTop: 10 }}>{t().site_comment__comment_loading}</p>
          )}
          <div>
            {siteComments.map((siteComment) => (
              <SiteComment
                key={siteComment.id}
                comment={siteComment}
                sitePerformanceEstimationFields={
                  sitePerformanceEstimationFields
                }
                isCanEdit={isCanEdit}
              />
            ))}
          </div>
          {siteComments.length == 0 && !isLoadComment && (
            <span style={{ marginTop: 10, display: "block" }}>
              {t().site_comment__no_comment}
            </span>
          )}
          {siteComments && siteComments.length < totalComments && (
            <Button
              disabled={isLoadComment}
              color={isLoadComment ? "secondary" : "primary"}
              onClick={loadMoreComment}
              style={styles.loadMoreButton}
            >
              {isLoadComment
                ? t().site_comment__loading
                : t().site_comment__loadmore}
            </Button>
          )}
        </div>
      </div>
    </TabPane>
  );
};

const styles = {
  commentBoxContainer: {
    backgroundColor: "var(--color-line-light)",
    borderRadius: 6,
    padding: 12,
  } as React.CSSProperties,
  commentBox: {
    backgroundColor: "var(--color-line-light)",
    border: "none",
    width: "100%",
    padding: 12,
    fontSize: 16,
  },
  commentButtonContainer: {
    backgroundColor: "var(--color-line-light)",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    paddingRight: 3,
    paddingBottom: 3,
  } as React.CSSProperties,
  loadMoreButton: {
    width: "100%",
    marginTop: 12,
    marginBottom: 12,
  },
};

export default SiteCommentTab;
